export const categories = [
  { value: "dentistry", label: "Odontologia" },
  { value: "preventive", label: "Preventivo" },
  { value: "grooming", label: "Estética" },
  { value: "diagnostics", label: "Diagnóstico" },
  { value: "consultation", label: "Consulta" },
  { value: "emergency", label: "Emergência" },
  { value: "surgery", label: "Cirurgia" },
  { value: "vaccination", label: "Vacinação" },
  { value: "lab_tests", label: "Exames Laboratoriais" },
  { value: "ultrasound", label: "Ultrassonografia" },
  { value: "x_ray", label: "Raio-X" },
  { value: "cardiology", label: "Cardiologia" },
  { value: "dermatology", label: "Dermatologia" },
  { value: "ophthalmology", label: "Oftalmologia" },
  { value: "oncology", label: "Oncologia" },
  { value: "nutrition", label: "Nutrição" },
  { value: "physiotherapy", label: "Fisioterapia" },
  { value: "endocrinology", label: "Endocrinologia" },
  { value: "hospitalization", label: "Hospitalização" },
  { value: "behavior", label: "Comportamento" },
] as const;